/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Steps_TitleInputs */

const en_svc_rag_steps_title = /** @type {(inputs: Svc_Rag_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How we build a knowledge base.`)
};

const lv_svc_rag_steps_title = /** @type {(inputs: Svc_Rag_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā mēs veidojam zināšanu bāzi.`)
};

/**
* | output |
* | --- |
* | "How we build a knowledge base." |
*
* @param {Svc_Rag_Steps_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_steps_title = /** @type {((inputs?: Svc_Rag_Steps_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Steps_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_steps_title(inputs)
	return en_svc_rag_steps_title(inputs)
});